import React from 'react';
import { styles } from "./styles";
export var GridHeaderContainer = React.memo(function (_a) {
    var children = _a.children, containerRef = _a.containerRef, style = _a.style, className = _a.className;
    return (React.createElement("div", { ref: containerRef, className: styles.container + " " + (className || ''), style: style }, children));
});
//# sourceMappingURL=GridHeaderContainer.js.map